export const ROADMAP = 'roadmap';
export const SATELLITE = 'satellite';
export const supportedTypes = [ROADMAP, SATELLITE];

export function isSupportedType(type) {
  return supportedTypes.indexOf(type) !== -1;
}
